import { useForm, SubmitHandler } from "react-hook-form";
import clsx from "clsx";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import styles from "./Modal.module.scss";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";
import PROVINCE from "../../../constants/province";
import DISTRICT from "../../../constants/district";
import WARD from "../../../constants/ward";
import { useEffect, useState } from "react";
import donationApi from "../../../apis/donationApi";
import { typeZeroWaste } from "../../../constants/constant";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


export interface ModalProps {
  className?: string;
  open: boolean;
  handleClose: () => void;
  isEdit?: boolean;
  setDataSubmit: any;
  handleSubmitModal: any;
  packgeType: string;
  provinceCode: string;
  setPackgeType: any;
  setProvinceCode: any;
  districtCode: string;
  setDistrictCode: any;
  wardCode: string;
  setWardCode: any;
  urbanFee?: any;
  parsePackageType?: any;
  setUrbanFee?: any;
}

type Inputs = {
  packageType: string;
  provinceID: string;
  districtID: string;
  wardID: string;
  urban_fee: any;
  suburban_fee: any;
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const convertPartnerPackageTypesConfigId = [
  { from: "1To5kg", to: "456" },
  { from: "6To10kg", to: "457" },
  { from: "11To15kg", to: "458" },
  { from: "16To20kg", to: "459"},
  { from: "21To30kg", to: "461"}
];

const ModalShippingFee = (props: ModalProps) => {
  const {
    className,
    open,
    handleClose,
    isEdit = false,
    setDataSubmit,
    handleSubmitModal,
    packgeType,
    provinceCode,
    setPackgeType,
    setProvinceCode,
    districtCode,
    setDistrictCode,
    wardCode,
    setWardCode,
    urbanFee,
    setUrbanFee,
  } = props;

  const { register, handleSubmit } = useForm<Inputs>();
  const [packgeTypeOption, setPackageTypeOption] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const payload = {
          filter: {
            ids: [],
            packageTypeId: "",
            partnerId: "",
          },
          paging: {
            limit: 0,
            offset: 0,
          },
        };
        const res = await donationApi.searchZeroWaste(payload);
        if (res.data.code === 0) {
          const list = res.data.data.data;
          const sorted = list.sort((a: any, b: any) => { const getNum = (name: string) => { const m = String(name).match(/\d+/); return m ? parseInt(m[0], 10) : 0; }; const nameA = typeZeroWaste(a.partnerPackageTypesConfigId) || a.packageTypeName || ""; const nameB = typeZeroWaste(b.partnerPackageTypesConfigId) || b.packageTypeName || ""; return getNum(nameA) - getNum(nameB); });
          const options = sorted.map((item: any) => ({
            label: typeZeroWaste(item.partnerPackageTypesConfigId) || item.packageTypeName || "Custom",
            packageType: item.partnerPackageTypesConfigId,
          }));
          setPackageTypeOption(options);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [open]);

  const rawWarehouseData = localStorage.getItem("warehouseData");
  const warehouseData = (rawWarehouseData && rawWarehouseData !== "undefined") ? JSON.parse(rawWarehouseData) : {};

  const getPartnerIdFromToken = (): string => {
    return process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
  };

  const [openSubmitConfirm, setOpenSubmitConfirm] = useState(false);
  const [submitData, setSubmitData] = useState<any>(null);

  const handleOpenSubmitConfirm = (data: Inputs) => {
    setSubmitData(data);
    setOpenSubmitConfirm(true);
  };

  const handleCloseSubmitConfirm = () => {
    setOpenSubmitConfirm(false);
    setSubmitData(null);
  };

  const onConfirmSubmit = () => {
    if (!submitData) return;
    const provinceName = PROVINCE.find((item) => item.code === provinceCode)?.label || provinceCode;
    const districtName = DISTRICT.find((item) => item.code === districtCode)?.name || districtCode || "";
    const wardName = WARD.find((item) => item.code === wardCode)?.name || wardCode || "";

    const dataParse = {
      partnerId: getPartnerIdFromToken(),
      partnerPackageTypesConfigId: packgeType,
      partnerWarehouseId: warehouseData?.id,
      price: parseFloat(submitData.urban_fee),
      provinceId: provinceName,
      districtId: districtName,
      wardId: wardName,
    };
    handleSubmitModal(dataParse);
    handleCloseSubmitConfirm();
  };

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    handleOpenSubmitConfirm(data);
  };

  return (
    <div className={clsx(styles.root, className && className)}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {isEdit ? (
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {" "}
              Sửa phí vận chuyển{" "}
            </Typography>
          ) : (
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {" "}
              Thêm mới phí vận chuyển{" "}
            </Typography>
          )}

          <form
            className={styles.formShippingFee}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={PROVINCE}
              value={
                PROVINCE.find((item) => item.code === provinceCode) || null
              }
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...register("provinceID")}
                  {...params}
                  label="Thành phố"
                />
              )}
              onChange={(event, value) => {
                setProvinceCode(value?.code);
                setDistrictCode("");
                setWardCode("");
              }}
            />

            <Autocomplete
              disablePortal
              id="combo-box-district"
              options={DISTRICT.filter(d => d.province_code === provinceCode)}
              value={
                DISTRICT.find((item) => item.code === districtCode) || null
              }
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...register("districtID")}
                  {...params}
                  label="Quận/Huyện"
                />
              )}
              onChange={(event, value) => {
                setDistrictCode(value?.code);
                setWardCode("");
              }}
              disabled={!provinceCode}
            />

            <Autocomplete
              disablePortal
              id="combo-box-ward"
              options={WARD.filter(w => w.district_code === districtCode)}
              value={
                WARD.find((item) => item.code === wardCode) || null
              }
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...register("wardID")}
                  {...params}
                  label="Phường/Xã"
                />
              )}
              onChange={(event, value) => setWardCode(value?.code)}
              disabled={!districtCode}
            />
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={
                DISTRICT.filter((item) => item.province_code === provinceCode) ||
                []
              }
              value={
                DISTRICT.find((item) => item.code === districtCode) || null
              }
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...register("districtID")}
                  {...params}
                  label="Quận/Huyện"
                />
              )}
              onChange={(event, value) => setDistrictCode(value?.code)}
              disabled={!provinceCode}
            />

            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={
                WARD.filter((item) => item.district_code === districtCode) || []
              }
              value={WARD.find((item) => item.code === wardCode) || null}
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.name || ""}
              renderInput={(params) => (
                <TextField
                  {...register("wardID")}
                  {...params}
                  label="Phường/Xã"
                />
              )}
              onChange={(event, value) => setWardCode(value?.code)}
              disabled={!districtCode}
            />

            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={packgeTypeOption}
              value={
                packgeTypeOption.find(
                  (item) => item.packageType === packgeType
                ) || null
              }
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...register("packageType")}
                  {...params}
                  label="Trọng lượng hàng"
                />
              )}
              onChange={(event, value) =>
                setPackgeType(value?.packageType)
              }
            />

            <TextField
              id="outlined-basic"
              label="Phí vận chuyển"
              variant="outlined"
              {...register("urban_fee", { required: true })}
              value={urbanFee}
              onChange={(e) => { setUrbanFee && setUrbanFee(e.target.value); }}
            />
            <Button
              className={styles.btnAddShippingFee}
              type="submit"
              variant="contained"
            >
              Lưu
            </Button>
          </form>
        </Box>
      </Modal>

      <Dialog
        open={openSubmitConfirm}
        onClose={handleCloseSubmitConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận lưu"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn lưu thông tin phí vận chuyển này không?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSubmitConfirm}>Hủy</Button>
          <Button onClick={onConfirmSubmit} autoFocus color="primary">
            Lưu
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalShippingFee;



